module.exports = __webpack_public_path__ + "media/images/pokerroom/pokerstars/step4-pict01-dce68fae176f585faed97d403b534093.jpg";